import React from 'react'
import { createBrowserRouter } from 'react-router-dom'

import { type QuizBasedGameType, Subject } from '@app/data'
import { BasicLayout, PageNotExist } from '@app/modules/common/view'

import { ErrorElement } from './ErrorElement'
import { Pages } from './PagesEnum'

const ClassroomPage = React.lazy(() => import('@app/modules/classroom/view/ClassroomPage/ClassroomPage'))

const DictionaryPage = React.lazy(() => import('@app/modules/library/view/DictionaryPage/DictionaryPage'))
const LearningPlanPage = React.lazy(() => import('@app/modules/learningPlan/pages/LearningPlanPage'))
const LearningPlanPageDetailPage = React.lazy(
  () => import('@app/modules/learningPlan/pages/LearningPlanPageDetailPage')
)
const DiscoveryPage = React.lazy(() => import('@app/modules/library/view/DiscoveryPage'))
const ManageClassPage = React.lazy(() => import('@app/modules/classroom/view/ManageClassPage/ManageClassPage'))
const MigrateClassPage = React.lazy(() => import('@app/modules/classroom/view/MigrateClassPage/MigrateClassPage'))
const SetupClassPage = React.lazy(() => import('@app/modules/classroom/view/SetupClassPage/SetupClassPage'))
const NewClassPage = React.lazy(() => import('@app/modules/classroom/view/NewClassPage/NewClassPage'))
const ClassroomPerformancePage = React.lazy(() => import('@app/modules/classPerformance/view/ClassPerformancePage'))

const UniversalGameEditorPage = React.lazy(
  () => import('@app/modules/games/pages/UniversalGameEditorPage/UniversalGameEditorPage')
)
const UnityGamePage = React.lazy(() => import('@app/modules/games/pages/UnityGamePage/UnityGamePage'))

export const router = createBrowserRouter([
  {
    path: Pages.ROOT,
    element: <BasicLayout />,
    errorElement: <ErrorElement />,
    children: [
      {
        index: true,
        element: <ClassroomPage />
      },
      {
        path: Pages.NEW_CLASS,
        element: <NewClassPage />
      },
      {
        path: Pages.CLASSROOM_DETAIL(':id'),
        element: <ClassroomPage />,
        children: [
          {
            index: true,
            element: <ClassroomPage />
          },
          {
            path: Pages.CLASSROOM_LEARNING_PLAN(':id'),
            element: <LearningPlanPage />
          },
          {
            path: Pages.CLASSROOM_LEARNING_PLAN_PAGE(':id', ':learningPlanId', ':pageId'),
            element: <LearningPlanPageDetailPage />
          },
          {
            path: Pages.CLASSROOM_UNIVERSAL_GAME_EDITOR(
              ':id',
              ':activityId',
              ':subject' as Subject,
              ':gameType' as QuizBasedGameType
            ),
            element: <UniversalGameEditorPage />
          },
          {
            path: Pages.CLASSROOM_PERFORMANCE(':id'),
            element: <ClassroomPerformancePage />
          },
          {
            path: Pages.CLASSROOM_MANAGE_CLASS(':id'),
            element: <ManageClassPage />
          },
          {
            path: Pages.CLASSROOM_MIGRATE_CLASS(':id'),
            element: <MigrateClassPage />
          },
          {
            path: Pages.CLASSROOM_SETUP_CLASS(':id'),
            element: <SetupClassPage />
          }
        ]
      },

      {
        path: Pages.DICTIONARY(':language'),
        element: <DictionaryPage />
      },
      {
        path: Pages.DISCOVERY(':language'),
        element: <DiscoveryPage />
      }
    ]
  },
  {
    path: Pages.UNITY_GAME,
    element: <UnityGamePage />
  },
  {
    path: '*',
    element: <PageNotExist />
  }
])
